import { useEffect, useRef } from "react";
import { ToolGuideChip } from "src/domains/shared/components/map/ToolGuideChip";
import { useMap } from "../hooks/incontext/useMap";
import { useControlSection } from "./layout/ControlSection";

/**
 * 2D 커서 안내 칩 어댑터 — ControlSection 의 안내 슬롯을 지도 뷰포트 위 공용 칩으로 그린다.
 * OL 은 화면 좌표를 즉시 얻으므로 3D 의 정밀 대기(loading) 변형은 여기 존재하지 않는다.
 */
export function MapToolGuideChip() {
  const map = useMap();
  const { toolGuide } = useControlSection();
  const containerRef = useRef<HTMLElement | null>(map.getViewport());

  useEffect(() => {
    containerRef.current = map.getViewport();
  }, [map]);

  if (toolGuide.rows === null) return null;

  return <ToolGuideChip containerRef={containerRef} rows={toolGuide.rows} />;
}
